module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "petition-counter"
  }, [_c('h5', [_vm._v("You have")]), _vm._v(" "), _c('h2', [_vm._v("\n       " + _vm._s(this.$store.getters.points) + " points\n     ")])]), _vm._v(" "), (_vm.isActive) ? _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true
      }),
      expression: "{ required: true, email: true}"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "name": "phone",
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('address')
    },
    attrs: {
      "name": "address",
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rewardid),
      expression: "rewardid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('rewards')
    },
    attrs: {
      "name": "rewards"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rewardid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a reward")]), _vm._v(" "), _vm._l((this.$store.getters.rewards), function(reward) {
    return _c('option', {
      domProps: {
        "value": reward.code
      }
    }, [_vm._v(_vm._s(reward.name) + " (" + _vm._s(reward.points) + " points)")])
  })], 2), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": _vm.save
    }
  }), _vm._v(" "), _vm._m(0, false, false)])])])]) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('div', {
    staticClass: "form-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.closingmessage))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("By signing you accept\n               "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("WWF-Australia’s Privacy Policy.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-347aae45","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!./~/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./src/components/LoyaltyForm.vue
// module id = 634
// module chunks = 0